import React, { memo, useMemo } from "react";
import { styles } from "./license-exam-entrance-card.style";
import { useLicenseExamEntranceCard } from "./license-exam-entrance-card.hook";
import { ExamMode, iconBgColorMap, iconColorMap, iconMap } from "./type";
import { useTranslation } from "react-i18next";
import { IconFontLayer } from "../../../../../../icon-font/iconfont-layer";
import { color } from "../../../../../../mui-theme/palette";
import { textStyleSet } from "../../../../../../mui-theme/text.style";
import { IconFont } from "../../../../../../icon-font/iconfont";
import { isPhone } from "../../../../../../constants/constants";

interface ComponentProps {}

export const LicenseExamEntranceCardComponent: React.FC<ComponentProps> = memo(
  (props: ComponentProps) => {
    const {
      handlePress,
      translations,
      displayedLicenses,
      isExpanded,
      showViewMore,
      handleToggleExpand,
    } = useLicenseExamEntranceCard(props);

    // PHKL Custom -s
    // COE Original Layout
    // return (
    //   <div className="py-3">
    //     <div className="flex flex-row items-center mb-3 mx-4">
    //       <p className="text-grey33" style={textStyleSet.text_18_bold}>
    //         {translations.title}
    //       </p>
    //     </div>
    //     {displayedLicenses.map((licenseOrExam, index) => (
    //       <LicenseExamItemComponent
    //         key={index}
    //         licenseOrExam={licenseOrExam}
    //         handlePress={handlePress}
    //       />
    //     ))}

    //     {showViewMore && (
    //       <div className="flex justify-center">
    //         <button onClick={handleToggleExpand} className="flex items-center">
    //           <span style={textStyleSet.text_14_med} className="text-grey66 mr-1">
    //             {isExpanded ? translations.viewLess : translations.viewMore}
    //           </span>
    //           <span className={`${isExpanded ? "inline-block rotate-180" : "inline-block"}`}>
    //             <IconFont size={24} name={"arrow_down"} color={color.grey66} />
    //           </span>
    //         </button>
    //       </div>
    //     )}
    //   </div>
    // );

    /* PHKL Layout */
    return (
      <div className="px-3 py-2 md:px-0">
        <div className="bg-white rounded-2xl">
          {/* Header */}
          <div className="flex items-center px-4 py-3 border-b border-gray-200">
            <p className="flex-1 text-[20px] font-semibold text-[#1A1A1A] leading-[28px]">
              {translations.title}
            </p>
          </div>

          {/* Content */}
          {displayedLicenses.map((licenseOrExam, index) => (
            <div key={index} className={`${index !== 0 ? "border-t border-gray-200" : ""}`}>
              <LicenseExamItemComponent licenseOrExam={licenseOrExam} handlePress={handlePress} />
            </div>
          ))}

          {showViewMore && (
            <div className="flex justify-center border-t border-gray-200">
              <button onClick={handleToggleExpand} className="flex items-center">
                <span style={textStyleSet.text_14_med} className="text-grey66 mr-1">
                  {isExpanded ? translations.viewLess : translations.viewMore}
                </span>
                <span className={`${isExpanded ? "inline-block rotate-180" : "inline-block"}`}>
                  <IconFont size={24} name={"arrow_down"} color={color.grey66} />
                </span>
              </button>
            </div>
          )}
        </div>
      </div>
    );
    // PHKL Custom -e
  },
);

interface LicenseExamItemProps {
  licenseOrExam: any;
  handlePress?: (licenseOrExam: any) => void;
}

const LicenseExamItemComponent: React.FC<LicenseExamItemProps> = ({
  licenseOrExam,
  handlePress,
}) => {
  // PHKL Custom -s
  // COE Original Layout
  // return (
  //   <div
  //     style={styles.contentContainer}
  //     onClick={() => handlePress?.(licenseOrExam)}
  //     className="aspect-ratio-1-1:rounded-xl cursor-pointer" /* PHKL Custom */
  //   >
  //     {!licenseOrExam.examSchedule ? (
  //       <LicenseExamItemV1 licenseOrExam={licenseOrExam} />
  //     ) : (
  //       <ExamRegistrationItem licenseOrExam={licenseOrExam} />
  //     )}
  //   </div>
  // );

  /* PHKL Layout */
  return (
    <div>
      {!licenseOrExam.examSchedule ? (
        <LicenseExamItemV1 licenseOrExam={licenseOrExam} handlePress={handlePress} />
      ) : (
        <ExamRegistrationItem licenseOrExam={licenseOrExam} handlePress={handlePress} />
      )}
    </div>
  );
  // PHKL Custom -e
};

const LicenseExamItemV1: React.FC<LicenseExamItemProps> = ({ licenseOrExam, handlePress }) => {
  // PHKL Custom -s
  const { t } = useTranslation();
  // COE Original Layout
  // const contentComponent = useMemo(() => {
  //   if (!licenseOrExam.examName) {
  //     return (
  //       <div className="flex flex-1 flex-col justify-center ml-3">
  //         <div className="flex flex-row items-center">
  //           <p className="text-grey33 flex-1" style={textStyleSet.text_16_med}>
  //             {licenseOrExam.description}
  //           </p>
  //           <div
  //             className="self-center rounded-[4px]"
  //             style={{
  //               backgroundColor: licenseOrExam.statusBackgroundColor,
  //             }}>
  //             <p
  //               className="px-2 py-1"
  //               style={{ ...textStyleSet.text_12_med, color: licenseOrExam.statusTextColor }}>
  //               {licenseOrExam.status}
  //             </p>
  //           </div>
  //         </div>
  //       </div>
  //     );
  //   }
  //   return (
  //     <div className="flex flex-1 flex-col justify-center ml-3">
  //       <div className="flex flex-row">
  //         <p className="text-grey99 flex-1 self-center" style={textStyleSet.text_14_med}>
  //           {licenseOrExam.examName}
  //         </p>
  //         <div
  //           className="self-start rounded-[4px]"
  //           style={{
  //             backgroundColor: licenseOrExam.statusBackgroundColor,
  //           }}>
  //           <p
  //             className="px-2 py-1"
  //             style={{ ...textStyleSet.text_12_med, color: licenseOrExam.statusTextColor }}>
  //             {licenseOrExam.status}
  //           </p>
  //         </div>
  //       </div>
  //       <p className="text-grey33 pt-1" style={textStyleSet.text_16_med}>
  //         {licenseOrExam.description}
  //       </p>
  //     </div>
  //   );
  // }, [licenseOrExam]);
  // return (
  //   <div className="flex flex-row items-center">
  //     <IconFontLayer
  //       size={36}
  //       backgroundSize={56}
  //       containerStyle={styles.iconContainer}
  //       name="licenseexam"
  //       color={color.majorRed}
  //     />
  //     {contentComponent}
  //   </div>
  // );

  /* PHKL Layout */
  return (
    <div className="px-4 py-4">
      <div className="flex md:flex-row md:items-start md:gap-4">
        {/* Left info section */}
        <div className="flex flex-1">
          {/* icon */}
          <div className="w-[56px] mr-3 flex-shrink-0 flex items-start">
            <IconFontLayer
              size={36}
              backgroundSize={56}
              containerStyle={styles.iconContainer}
              name="licenseexam"
              color={color.majorRed}
            />
          </div>

          <div className="flex flex-col flex-1 min-w-0 justify-center">
            {/*  content */}
            <div
              className="flex items-start gap-1 mt-1 text-grey33"
              style={textStyleSet.text_16_med}>
              <span className="break-words">{licenseOrExam.description}</span>
            </div>
            <div className="flex items-center gap-2 pt-1">
              <span
                className="px-2 py-1"
                style={{
                  backgroundColor: licenseOrExam.statusBackgroundColor,
                  color: licenseOrExam.statusTextColor,
                  ...textStyleSet.text_12_med,
                }}>
                {t(licenseOrExam.statusI18nKey)}
              </span>
            </div>
          </div>
        </div>

        {/* Desktop buttons */}
        <div className="hidden md:flex flex-col gap-3 items-start">
          <button
            className="flex items-center justify-center w-[105px] h-9 rounded text-sm font-semibold text-white bg-[#E8192C] hover:bg-[#d32f2f]"
            onClick={() => handlePress?.(licenseOrExam)}>
            {t("Common.enroll_now")}
          </button>
        </div>
      </div>

      {/* Mobile buttons */}
      <div className="flex gap-2 mt-6 w-full justify-end md:hidden">
        <button
          className="flex items-center justify-center w-full h-9 rounded text-sm font-semibold text-white bg-[#E8192C] hover:bg-[#d32f2f]"
          onClick={() => handlePress?.(licenseOrExam)}>
          {t("Common.enroll_now")}
        </button>
      </div>
    </div>
  );
  // PHKL Custom -e
};

const ExamRegistrationItem: React.FC<LicenseExamItemProps> = ({ licenseOrExam, handlePress }) => {
  const { t } = useTranslation();
  // PHKL Custom -s
  // COE Original Layout
  // return (
  //   <div className="flex flex-row items-center">
  //     {/** PHKL Custom: -s */}
  //     <div className="items-center">
  //       <IconFontLayer
  //         size={36}
  //         backgroundSize={56}
  //         containerStyle={{
  //           ...styles.iconContainer,
  //           justifySelf: "center", // PHKL Custom
  //           backgroundColor:
  //             iconBgColorMap[(licenseOrExam.examMode ?? ExamMode.DEFAULT) as ExamMode],
  //         }}
  //         name={iconMap[(licenseOrExam.examMode ?? ExamMode.DEFAULT) as ExamMode]}
  //         color={iconColorMap[(licenseOrExam.examMode ?? ExamMode.DEFAULT) as ExamMode]}
  //       />
  //       {[ExamMode.COMPUTER, ExamMode.PAPER].includes(licenseOrExam.examMode) ? (
  //         <p
  //           className="text-grey33"
  //           style={{ ...textStyleSet.text_12_med, textAlign: "center", marginTop: 5 }}>
  //           {t(`Common.${licenseOrExam.examMode}`)}
  //         </p>
  //       ) : null}
  //     </div>
  //     <div className="flex flex-1 flex-col ml-3">
  //       {isPhone ? (
  //         <>
  //           <div
  //             style={{
  //               backgroundColor: licenseOrExam.statusBackgroundColor,
  //               placeSelf: "flex-end",
  //             }}
  //             className="rounded-[4px]">
  //             <p
  //               className="px-2 py-1"
  //               style={{ ...textStyleSet.text_12_med, color: licenseOrExam.statusTextColor }}>
  //               {t(licenseOrExam.statusI18nKey)}
  //             </p>
  //           </div>
  //           <div className="flex flex-1 items-center">
  //             <p className="text-grey99 flex-1 self-center" style={textStyleSet.text_14_med}>
  //               {licenseOrExam.examName}
  //             </p>
  //           </div>
  //         </>
  //       ) : (
  //         <div className="flex flex-row">
  //           <div className="flex flex-1 items-center">
  //             <p className="text-grey99 flex-1 self-center" style={textStyleSet.text_14_med}>
  //               {licenseOrExam.examName}
  //             </p>
  //           </div>
  //           <div
  //             style={{
  //               backgroundColor: licenseOrExam.statusBackgroundColor,
  //             }}
  //             className="self-start rounded-[4px]">
  //             <p
  //               className="px-2 py-1"
  //               style={{ ...textStyleSet.text_12_med, color: licenseOrExam.statusTextColor }}>
  //               {t(licenseOrExam.statusI18nKey)}
  //             </p>
  //           </div>
  //         </div>
  //       )}
  //       {/** PHKL Custom: -e */}
  //       <div>
  //         {licenseOrExam.score ? (
  //           <p className="text-grey33 pt-1" style={textStyleSet.text_16_med}>
  //             {t("Common.score")}: {licenseOrExam.score}
  //             {"  "}
  //             <span style={{ color: color.greycf }}>|</span>
  //             {"  "}
  //             {t("Common.result")}: {t(licenseOrExam.statusI18nKey)}
  //           </p>
  //         ) : null}
  //         <p className="text-grey33 pt-1" style={textStyleSet.text_16_med}>
  //           <IconFont name="time-event" size={16} color={color.grey33} />
  //           {"  "}
  //           {licenseOrExam.examSchedule}
  //         </p>
  //         {/** PHKL Custom: -s */}
  //         {licenseOrExam.examScheduleTime && (
  //           <p className="text-grey33 pt-1" style={{ ...textStyleSet.text_16_med, marginLeft: 20 }}>
  //             {licenseOrExam.examScheduleTime}
  //           </p>
  //         )}
  //         {/** PHKL Custom: -e */}
  //         <p className="text-grey33 pt-1" style={textStyleSet.text_16_med}>
  //           <IconFont name="location-event" size={16} color={color.grey33} />
  //           {"  "}
  //           {licenseOrExam.examCentre}
  //         </p>
  //         {/* PHKL Custom -s
  //         {[ExamMode.COMPUTER, ExamMode.PAPER].includes(licenseOrExam.examMode) ? (
  //           <>
  //             <p
  //               className="text-grey33 pt-1"
  //               style={{ ...textStyleSet.text_16_med, marginLeft: 20 }}
  //             >

  //               <IconFont
  //                 size={16}
  //                 name={iconMap[(licenseOrExam.examMode ?? ExamMode.DEFAULT) as ExamMode]}
  //                 color={color.grey33}
  //               />
  //               {t(`Common.${licenseOrExam.examMode}`)}
  //             </p>
  //             {/* PHKL Custom -s
  //             {licenseOrExam?.deviceType ? (
  //               <div className="flex flex-row pt-1 pl-5" style={textStyleSet.text_14_med}>
  //                 <span>
  //                   {"  "}
  //                   {t("Device")}:{" "}
  //                 </span>
  //                 <span className="pl-2">{licenseOrExam.deviceType}</span>
  //               </div>
  //             ) : null}

  //           </>
  //         ) : null}
  //          PHKL Custom -e */}
  //       </div>
  //     </div>
  //   </div>
  // );

  /* PHKL Layout */
  return (
    <div className="px-4 py-4">
      <div className="flex md:flex-row md:items-start md:gap-4">
        {/* Left info section */}
        <div className="flex flex-1">
          {/* icon */}
          <div className="w-[56px] mr-3 flex-shrink-0 flex items-start">
            <IconFontLayer
              size={36}
              backgroundSize={56}
              containerStyle={{
                ...styles.iconContainer,
                justifySelf: "center",
                backgroundColor:
                  iconBgColorMap[(licenseOrExam.examMode ?? ExamMode.DEFAULT) as ExamMode],
              }}
              name={iconMap[(licenseOrExam.examMode ?? ExamMode.DEFAULT) as ExamMode]}
              color={iconColorMap[(licenseOrExam.examMode ?? ExamMode.DEFAULT) as ExamMode]}
            />
          </div>

          <div className="flex flex-col flex-1 min-w-0">
            <span className="text-[17px] font-semibold leading-[24px]">
              {licenseOrExam.examName}
            </span>
            <div className="flex items-center gap-2 pt-1">
              <span
                className="px-2 py-1"
                style={{
                  backgroundColor: licenseOrExam.statusBackgroundColor,
                  color: licenseOrExam.statusTextColor,
                  ...textStyleSet.text_12_med,
                }}>
                {t(licenseOrExam.statusI18nKey)}
              </span>

              {licenseOrExam.score && (
                <span className="text-grey33" style={textStyleSet.text_16_med}>
                  {t("Common.score")}: {licenseOrExam.score}
                </span>
              )}
            </div>

            <p className="text-grey33 pt-1" style={textStyleSet.text_16_med}>
              <IconFont name="time-event" size={16} color={color.grey33} />
              {"  "}
              {licenseOrExam.examSchedule}
            </p>
            {licenseOrExam.examScheduleTime && (
              <p
                className="text-grey33 pt-1"
                style={{ ...textStyleSet.text_16_med, marginLeft: 20 }}>
                {licenseOrExam.examScheduleTime}
              </p>
            )}
            <p className="text-grey33 pt-1" style={textStyleSet.text_16_med}>
              <IconFont name="location-event" size={16} color={color.grey33} />
              {"  "}
              {licenseOrExam.examCentre}
            </p>
            {[ExamMode.COMPUTER, ExamMode.PAPER].includes(licenseOrExam.examMode) ? (
              <p className="text-grey33 pt-1" style={textStyleSet.text_16_med}>
                <IconFont
                  name={iconMap[(licenseOrExam.examMode ?? ExamMode.DEFAULT) as ExamMode]}
                  size={16}
                  color={color.grey33}
                />
                {"  "}
                {t(`Common.${licenseOrExam.examMode}`)}
              </p>
            ) : null}
          </div>
        </div>

        {/* Desktop buttons */}
        <div className="hidden md:flex flex-col gap-3 items-start">
          <button
            className="flex items-center justify-center w-[105px] h-9 rounded text-sm font-semibold text-white bg-[#E8192C] hover:bg-[#d32f2f]"
            onClick={() => handlePress?.(licenseOrExam)}>
            {t("exam_detail")}
          </button>
        </div>
      </div>

      {/* Mobile buttons */}
      <div className="flex gap-2 mt-6 w-full justify-end md:hidden">
        <button
          className="flex items-center justify-center w-full h-9 rounded text-sm font-semibold text-white bg-[#E8192C] hover:bg-[#d32f2f]"
          onClick={() => handlePress?.(licenseOrExam)}>
          {t("exam_detail")}
        </button>
      </div>
    </div>
  );
  // PHKL Custom -e
};
